import { IErrorInfo } from "../error-info";

export interface IApiresponse<T> {
    responseInfo: T;
    webApiName: number;
    webApiVersion: number;
    requestId: string;
    statusCode: number;
    message: string;
    responseTimeStamp: number;
    errorInfo: IErrorInfo[];
}

export class Apiresponse<T> implements IApiresponse<T> {
    responseInfo: T;
    webApiName: number;
    webApiVersion: number;
    requestId: string;
    statusCode: number;
    message: string;
    responseTimeStamp: number;
    errorInfo: IErrorInfo[];

    // constructor(responseInfo: T,
    //     WebApiName: number,
    //     WebApiVersion: number,
    //     RequestId: string,
    //     StatusCode: number,
    //     Message: string,
    //     ResponseTimeStamp: number,
    //     ErrorInfo: any[]) {

    //     this.WebApiName = WebApiName;
    //     this.WebApiVersion = WebApiVersion;
    //     this.RequestId = RequestId;
    //     this.StatusCode = StatusCode;
    //     this.Message = Message;
    //     this.ResponseTimeStamp = ResponseTimeStamp;
    //     this.ErrorInfo = ErrorInfo;


    // }
}

// https://www.typescriptlang.org/docs/handbook/generics.html
